import { HOTEL_FILTER_CHANGED } from '../../../../../../actions/filters';

import type { ChangeHotelFilterAction } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { SelectedHotelsFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/hotelsFilter';

export const INITIAL_STATE: SelectedHotelsFilterState = {
  filterName: 'Best',
  pillIdentifier: 'common_best_v1',
  selectedOptionIndex: 0,
};
export const selectedHotelFilter = (
  state: SelectedHotelsFilterState = INITIAL_STATE,
  action: ChangeHotelFilterAction,
): SelectedHotelsFilterState => {
  switch (action.type) {
    case HOTEL_FILTER_CHANGED:
      return {
        filterName: action.payload.filterName,
        pillIdentifier: action.payload.pillIdentifier,
        selectedOptionIndex: action.payload.selectedOptionIndex,
      };

    default:
      return state;
  }
};
export default selectedHotelFilter;
export const get = (state: SelectedHotelsFilterState): SelectedHotelsFilterState => state;
